module.exports = __webpack_public_path__ + "static/img/processEngine.fe9010e2.png";